/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { currencySymbolEnumSchema } from "./currencySymbolEnumSchema.ts";
import { defaultLanguageEnumSchema } from "./defaultLanguageEnumSchema.ts";
import { loyaltyEnumSchema } from "./loyaltyEnumSchema.ts";
import { orderPaymentMethodEnumSchema } from "./orderPaymentMethodEnumSchema.ts";
import { orderTypeSchema } from "./orderTypeSchema.ts";
import { supportedLanguagesEnumSchema } from "./supportedLanguagesEnumSchema.ts";

export const orgUnitGuestSchema = z.object({
	id: z.uuid(),
	name: z.string().max(255),
	subdomain: z
		.string()
		.max(63)
		.regex(/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/)
		.nullish()
		.describe("Уникальный поддомен для точки организации (например: 'test-point')."),
	organization: z.uuid(),
	currency_symbol: currencySymbolEnumSchema.describe("* `₽` - RUB\n* `$` - USD\n* `₸` - KZT\n* `€` - EUR\n* `₾` - GEL\n* `֏` - AMD\n* `AED` - AED"),
	default_language: defaultLanguageEnumSchema.describe(
		"* `ru` - Русский\n* `en` - Английский\n* `es` - Испанский\n* `ar` - Арабский\n* `zh` - Китайский\n* `kk` - Казахский\n* `hy` - Армянский\n* `ka` - Грузинский\n* `az` - Азербайджанский\n* `uz` - Узбекский",
	),
	quick_add_simple: z.boolean().optional().describe("Включает режим быстрого добавления простых блюд (без модификаторов/размеров) в корзину"),
	supported_languages: supportedLanguagesEnumSchema
		.optional()
		.describe(
			"* `ru` - Русский\n* `en` - Английский\n* `es` - Испанский\n* `ar` - Арабский\n* `zh` - Китайский\n* `kk` - Казахский\n* `hy` - Армянский\n* `ka` - Грузинский\n* `az` - Азербайджанский\n* `uz` - Узбекский",
		),
	enable_qr: z.boolean().optional(),
	loyalty: loyaltyEnumSchema.nullable(),
	has_loyalty_default_user: z.boolean(),
	infinite_feed_qr: z.boolean().optional(),
	enable_flat_product_feed: z.boolean().optional(),
	qr_enable_flat_product_feed: z.boolean(),
	kiosk_enable_flat_product_feed: z.boolean().optional(),
	latitude: z.number().nullish(),
	longitude: z.number().nullish(),
	qr_order_minimum_price: z.int().min(0).max(2147483647).optional().describe("Минимальная сумма заказа для оформления (0 - ограничение отсутствует)"),
	kiosk_order_minimum_price: z.int().min(0).max(2147483647).optional().describe("Минимальная сумма заказа для оформления (0 - ограничение отсутствует)"),
	enable_sequential_modifiers: z
		.boolean()
		.optional()
		.describe("Если включено: заменяет вкладки на кнопку «Продолжить» для последовательного перехода между группами."),
	qr_is_order_comment_required: z.boolean(),
	kiosk_is_order_comment_required: z.boolean(),
	kiosk_enable_wheel: z.boolean(),
	order_payment_method: orderPaymentMethodEnumSchema
		.optional()
		.describe(
			"Применяется только к заказам в режиме Ресторан (ТС).\n\n* `PARTIAL` - Разрешить частичную оплату\n* `FULL_ONLY` - Разрешить только полную оплату\n* `DISABLED` - Запретить оплату",
		),
	default_table: z.string(),
	is_hidden: z.boolean().optional(),
	default_country_code: z.string(),
	hash_sum: z.string(),
	combos_hash_sum: z.string().nullable(),
	block_calculate_discount: z
		.boolean()
		.optional()
		.describe(
			"Параметр отключает предрасчёт скидок iikoCard на нашей стороне (корзина и создание заказа). На точках с созданием через плагин скидки при этом применяет сама касса (fixedLoyaltyDiscounts=false); на TRN-точках скидки iikoCard подавляются полностью. Для корзин с комбо расчёт выполняется всегда — иначе комбо уходит по полной цене.",
		),
	order_types: z.array(orderTypeSchema),
	order_item_comment_suggestions: z.array(z.string()),
	marking_scan_enabled: z.boolean(),
	marking_removal_confirmation_enabled: z
		.boolean()
		.optional()
		.describe(
			"Выключено — гость удаляет маркированную позицию из корзины, повторно отсканировав товар. Включено — нужен пин-код или штрихкод сотрудника из дизайн-конфигурации организации (блок «Киоск — Маркировка (Честный знак)»).",
		),
	queue_domain: z.url().nullable(),
	reserve_enabled: z.boolean().optional(),
	delivery_enabled: z
		.boolean()
		.optional()
		.describe("Гости видят доставку и самовывоз только при включённой галочке. Касса, типы заказа и время доставки — в «Настройках доставки» точки"),
	allow_multiple_orders_on_table: z
		.boolean()
		.optional()
		.describe(
			"При сканировании стола гость получает СПИСОК актуальных заказов стола (за последние сутки, в статусах «Подтвержден пользователем», «Ожидает оплаты», «Частично оплачен») и сам выбирает, к какому присоединиться. Стол при этом никогда не считается занятым: гость может завести на нём новый заказ, даже если другие заказы ещё открыты. При выключенной галочке поведение прежнее: гостю отдаётся только один, самый свежий подходящий заказ, а создать новый на занятом столе нельзя.",
		),
	display_likes: z.boolean().optional(),
});
